import { render, staticRenderFns } from "./IpBundleForm.vue?vue&type=template&id=84af92be&scoped=true&"
import script from "./IpBundleForm.vue?vue&type=script&lang=js&"
export * from "./IpBundleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84af92be",
  null
  
)

export default component.exports